<template>
  <flexible-slider-section
    :section="{ title: 'Inne tej marki', data: { products: data } }"
    :h-tag="false"
    v-if="data && data.length"
    :loading="loading"
  />
</template>

<script>
import FlexibleSliderSection from '~/components/Flexible/FlexibleSliderSection';

export default {
  name: 'ProductOthers',
  components: { FlexibleSliderSection },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  async fetch() {
    if (this.products.length) {
      this.data = this.products;
      this.loading = false;
    } else {
      try {
        const { data } = await this.$axios.get(
          `${this.$config.baseOfixApi}/e-commerce/v1/products/${this.$route.params.slug}`,
          {
            params: {
              includeBreadcrumbs: false,
              includeProduct: false,
              includeSeoData: false,
              includeAccessories: false,
              includeSimilarProducts: false,
              includeOtherProducts: false,
              includeOtherProductsWithSameBrand: true,
            },
            useCache: true,
          },
        );
        this.data = data.otherProductsWithSameBrand;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    }
  },
  data() {
    return {
      loading: true,
      data: null,
    };
  },
  watch: {
    data(val) {
      if (val && val.length) {
        this.$emit('productSectionData', true);
      }
    },
  },
};
</script>
